// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j7-1";
export var stateContainer = "_j7-0";